import LoadingSpinner from 'components/elements/Spinner/LoadingSpinner';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useAuth } from 'services/auth-service';
import AccountService, { AccountProps } from 'services/hooks/account-service';
// import BuildingView from '../Building/BuildingViewMode';
import TopBar from 'components/elements/TopBar';
import { useQuery } from 'react-query';

export default function AccountViewMode() {
  const {
    state: { user }
  } = useAuth();

  /* The code is using the `useState` hook from React to define and initialize state variables. */
  const [selectedBuilding, setSelectedBuilding] = useState<{ value: string; label: string } | null>(
    null
  );

  /* The code is using the `useQuery` hook from the `react-query` library to fetch account data. */
  const { isSuccess, data, isLoading } = useQuery<AccountProps, Error>(
    'account',
    () => AccountService.findAccountById(user.uuid),
    {
      onError: (err: any) => {
        console.log(err.response?.data || err);
      }
    }
  );

  /* The code is creating an `options` array by mapping over the `data.buildings` array. It checks if
  `data.buildings` exists (`data?.buildings`) and if not, it uses an empty array (`[]`). For each
  `building` in the `data.buildings` array, it creates an object with a `value` property set to
  `building.uuid` or an empty string if `building.uuid` is undefined, and a `label` property set to
  `building.name`. This `options` array is used as the options for the `Select` component. */
  const options = (data?.buildings || []).map((building) => ({
    value: building.uuid || '', // Provide a default value if uuid is undefined
    label: building.name
  }));

  /* The `useEffect` hook is used to set the first building as the default selected value. It runs when
  the component is rendered and whenever the `options` or `selectedBuilding` variables change. */
  useEffect(() => {
    if (options.length > 0 && !selectedBuilding) {
      setSelectedBuilding(options[0]);
    }
  }, [options, selectedBuilding]);

  return !isLoading && data && isSuccess ? (
    <div className="container space-y-4">
      <TopBar setGlobalFilter={false} isMessage={true} />
      <div className="bg-neutral1 py-4 px-4">
        <div className="p-4 shadow-md shadow-neutral4">
          <h4 className="text-lg font-semibold mb-4">ACCOUNT</h4>
          <div className="p-4 shadow">
            <div className="mb-2">
              <span className="font-semibold">Name:</span> {data?.name}
            </div>
            <div className="mb-2">
              <span className="font-semibold">Contract Duration:</span>{' '}
              {data?.contractStartDate &&
                `${format(new Date(data?.contractStartDate), 'dd MMMM yyyy')} to ${format(
                  new Date(data?.contractEndDate),
                  'dd MMMM yyyy'
                )}`}
            </div>
            <div>
              <span className="font-semibold">Status:</span>{' '}
              {data?.isActive ? 'Active' : 'Deactivated'}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div>
      <LoadingSpinner />
    </div>
  );
}
